<template>
  <div>
    <heads></heads>
    <div class="messenger-center">

      <div class="messenger-border">
        <div class="messengerCen">
          <div class="messenger-logo">
            <!-- <div class="logo-kf"><img :src="globalConfig.imgUrl+logo"/></div>-->
            <div class="logo-title">
              <div v-for="item in tip" v-html="item.content"></div>
            </div>
          </div>
          <div class="messenger-list">
            <div v-for="item in list">
              <span class="lineIcon"><img :src="globalConfig.imgUrl+item.messenger_picture"/></span>
              <span class="messengerName">
                 <em>{{item.messenger_name}}</em>
                 <em>{{item.messenger_account}}</em>
              </span>
              <span class="messengerCopy" @click.stop="onCopy(item.messenger_account,item.messenger_sheme)">{{$t('messenger.copy')}}</span>
              <span class="qr" @click.stop="_qrPath(item.messenger_qrcode)"><em>Q</em><em>R</em></span>
            </div>
            <div @click.stop="_Customer(1)">
              <span class="lineIcon" ><img src="../assets/img/kf.png"/></span>
              <span class="messengerName">
                 <em>{{$t('Online.title')}}</em>
              </span>
            </div>
            <!-- <div @click.stop="_Customer(2)">
               <span class="lineIcon" ><img src="../assets/img/kf.png"/></span>
               <span class="messengerName">
                  <em>{{$t('Recharge.title')}}</em>
               </span>
             </div>-->
          </div>
        </div>

      </div>
      <div class="qrcode-cover" v-if="isQr==1" @click.stop="_openQr(1)">
        <div class="qr-center" @click.stop="_openQr"><img :src="globalConfig.imgUrl+qrpath"/></div>
      </div>
    </div>
  </div>

</template>

<script>
  import heads from './navs/headr'
    export default {
        name: "messenger",
      components:{heads},
      data(){
          return{
            list:[],
            isQr:0,
            tip:[],
          }
      },
      created:function(){
          let _self=this;
          _self._online_messenger();
          _self._customerTip()
      },
      methods:{
        _customerTip:function(){
          let _self=this;
          this._PublicFun.getData('1', 'get', 'article/9', {}, function (result) {
            if(result.data['status_code']==200){
              _self.tip=result.data['data'];
            }
          })
        },
        _openQr:function(m){
          if(m==1){
            this.isQr=0;
          }
        },
        _qrPath:function(messenger_qrcode){
          let _self=this;
          _self.qrpath=messenger_qrcode;
          _self.isQr=1;
        },
          _Customer:function(m){
            let _self=this;

            if(m==2){
              let token=_self.GLOBAL.fetch('token');
              if(token.length!=0){
                _self.$router.push({path:'/user/Recharge'});
              }else{
                Toast(_self.$t('home.login'))
              }
            }else{
              _self.$router.push({path:'/online'});
            }
          },
        onCopy(messenger_account,messenger_sheme) {
          let _self=this;
          this.$copyText(messenger_account).then(
            function(e) {
              Toast(_self.$t('messenger.success'));
              window.open(messenger_sheme)
            },
            function(e) {
              Toast(_self.$t('messenger.err'));
            }
          );
        },
        _online_messenger:function () {
          let _self=this;
          this._PublicFun.getData('1', 'get', 'online_messenger', {}, function (result) {
            if(result.data['status_code']==200){
              _self.list=result.data['data'];
            }

          })
        },
      }
    }
</script>

<style scoped>
 @import "../assets/css/messenger.css";
</style>



// WEBPACK FOOTER //
// src/components/messenger.vue